import dayjs, { Dayjs } from 'dayjs';

export type ShotOnConstraints = {
  minDate: Dayjs | undefined;
  maxDate: Dayjs | undefined;
  defaultDate: Dayjs | null;
  isValid: (date: Dayjs | null) => boolean;
};

export const getShotOnConstraints = (
  startsOn: string | null,
  endsOn: string | null
): ShotOnConstraints => {
  const today = dayjs().startOf('day');

  const minDate = startsOn ? dayjs(startsOn).startOf('day') : undefined;

  const periodEnd = endsOn ? dayjs(endsOn).startOf('day') : today;
  const maxDate = periodEnd.isAfter(today) ? today : periodEnd;

  const defaultDate = ((): Dayjs | null => {
    if (minDate && today.isBefore(minDate)) {
      return minDate;
    }

    if (today.isAfter(maxDate)) {
      return maxDate;
    }

    return today;
  })();

  const isValid = (date: Dayjs | null): boolean => {
    if (!date) {
      return false;
    }

    const normalized = date.startOf('day');

    if (normalized.isAfter(today)) {
      return false;
    }

    if (minDate && normalized.isBefore(minDate)) {
      return false;
    }

    if (normalized.isAfter(maxDate)) {
      return false;
    }

    return true;
  };

  return {
    minDate,
    maxDate,
    defaultDate,
    isValid,
  };
};
